import { render, staticRenderFns } from "./editMarquee.vue?vue&type=template&id=6eae4ab8&lang=pug"
import script from "./editMarquee.vue?vue&type=script&lang=js"
export * from "./editMarquee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports